// extracted by mini-css-extract-plugin
export default {"container":"layout-two-rows_container__KRQ0a"};